import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import PropTypes from "prop-types";
import getAppConfig from '../../config/AppConfig';

class Footer extends Component {
    render() {

        const siteUrl = getAppConfig("siteUrl");

        //Support loop start
        const supportLinks = this.props.supportsLinks.map((support, index) => (
            <li key={index}>
                <a href={support.Link}>
                    <i className="icofont-double-right" />
                    {support.Name}
                </a>
            </li>
        ));
        //Support loop END

        return (
            <React.Fragment>
                <footer className="footer-area ptb-100">
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-3 col-md-6">
                                <div className="single-footer">
                                    <h4 className="logo">
                                        <a href="#home">
                                            Pitch In<span>&nbsp;Club</span>
                                        </a>
                                    </h4>
                                    <p>{this.props.siteDescription}</p>
                                    <a className="btn btn-primary" href={`${getAppConfig("siteUrl")}/resources/about-us`}>{this.props.btnText}</a>
                                   {/* <Link to="/faq" className="btn btn-primary">
                                        {this.props.btnText}
                                   </Link> */}
                                </div>
                            </div>

                            {/* This is First List of Resources */}
                            <div className="col-lg-3 col-md-6">
                                <div className="single-footer footer-navbar-nav">
                                    <h3>{this.props.usefullLinksTitle1}</h3>
                                    <ul>
                                        <li>
                                            <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/features`}>
                                                <i className="icofont-double-right" />
                                                Features
                                            </a>
                                            {/* <Link to="/resources/features">
                                                <i className="icofont-double-right" />
                                                Features
                                        </Link> */}
                                        </li>
                                        <li>
                                            <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/type-of-events`}>
                                                <i className="icofont-double-right" />
                                                Type of Events
                                            </a>
                                            {/*<Link to="/resources/type-of-events">
                                                <i className="icofont-double-right" />
                                                Type of Events
                                            </Link> */}
                                        </li>
                                        <li>
                                            <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/helping-hands`}>
                                                <i className="icofont-double-right" />
                                                Helping Hands List
                                            </a>
                                            {/*<Link to="/resources/helping-hands">
                                                <i className="icofont-double-right" />
                                                Helping Hands List
                                             </Link>*/}
                                        </li>
                                        <li>
                                            <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/contribution-list`}>
                                                <i className="icofont-double-right" />
                                                Contribution List
                                            </a>
                                            {/*
                                            <Link
                                                to="/resources/contribution-list">
                                                <i className="icofont-double-right" />
                                                Contributions List
                                            </Link>*/}
                                        </li>
                                        <li>
                                            <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/faq`}>
                                                    <i className="icofont-double-right" />
                                                    FAQ
                                            </a>
                                            {/* <Link to="/resources/faq">
                                                <i className="icofont-double-right" />
                                                FAQ
                                            </Link> */}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* Second List of Resources */}
                            <div className="col-lg-3 col-md-6">
                            <div className="single-footer footer-navbar-nav">
                                <h3 style={{color: '#95A5A6'}}>{this.props.usefullLinksTitle2}</h3>
                                <ul>
                                    <li>
                                        <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/how-to-create-event`}>
                                            <i className="icofont-double-right" />
                                            How to Create Event
                                        </a>
                                        {/*<Link to="/resources/how-to-create-event" >
                                            <i className="icofont-double-right" />
                                            How to Create Event
                                         </Link> */}
                                    </li>

                                    <li>
                                        <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/how-to-pitch-in`}>
                                            <i className="icofont-double-right" />
                                            How to Pitch In
                                        </a>
                                        {/*<Link to="/resources/how-to-pitch-in" >
                                            <i className="icofont-double-right" />
                                            How to Pitch In
                                        </Link>*/}
                                    </li>
                                    <li>
                                        <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/event-planning-tools`}>
                                                <i className="icofont-double-right" />
                                                Event Planning Tools
                                        </a>
                                        {/* <Link to="/resources/faq">
                                            <i className="icofont-double-right" />
                                            FAQ
                                        </Link> */}
                                    </li>
                                    <li>
                                         <a className="btnx btn-primaryx" href={`${getAppConfig("siteUrl")}/resources/about-us`}>
                                            <i className="icofont-double-right" />
                                            About Us
                                        </a>
                                        {/*<Link to="/resources/about-us" >
                                            <i className="icofont-double-right" />
                                            About Us
                                         </Link>*/}
                                    </li>

                                    {/*
                                    <li>
                                        <NavLink
                                            to="/resources/how-to-pitch-in"
                                            activeClassName=""
                                        >
                                            <i className="icofont-double-right" />
                                            How to Pitch In
                                        </NavLink>
                                    </li>
                                    */}
                                </ul>
                            </div>
                        </div>
                       {/*  Remove this section to be able to spread resources into two columns 
                            <div className="col-lg-3 col-md-6">
                                <div className="single-footer">
                                    <h3 className="color-w">{this.props.supportTitle}</h3>
                                    <ul>{supportLinks}</ul>
                                </div>
                            </div>
                        */}    
                            <div className="col-lg-3 col-md-6">
                                <div className="single-footer">
                                    <h3>{this.props.contactInfoTitle}</h3>
                                    <p>{this.props.contactInfoText}</p>
                                    <ul className="contact-info">
                                        <li>
                                            <i className="icofont-google-map" />
                                            {this.props.address}
                                        </li>
                                        <li>
                                            <i className="icofont-phone" />
                                            {this.props.phone}
                                        </li>
                                        <li>
                                            <i className="icofont-envelope" />
                                            {this.props.email}
                                            <Link to="/contact-form">Contact Form</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                                           
                        </div>
                    </div>
                    

                    <div className="copyright-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-7 col-md-7">
                                    <p>{this.props.copyRightText}</p>
                                </div>
                                <div className="col-lg-5 col-md-5">
                                    <ul>
                                        {this.props.fbLink && (
                                            <li>
                                                <a className="icofont-facebook" href={this.props.fbLink}></a>
                                            </li>
                                        )}

                                        {this.props.linkedinlLink && (
                                            <li>
                                                <a className="icofont-linkedin" href={this.props.linkedinlLink}></a>
                                            </li>
                                        )}

                                        {this.props.twitterlLink && (
                                            <li>
                                                <a className="icofont-twitter" href={this.props.twitterlLink}
                                                    
                                                />
                                            </li>
                                        )}
                                        {/*
                                        {this.props.instagramlLink && (
                                            <li>
                                                <Link
                                                    to={
                                                        this.props
                                                            .instagramlLink
                                                    }
                                                    className="icofont-instagram"
                                                />
                                            </li>
                                        )}

                                        {this.props.vimeolLink && (
                                            <li>
                                                <Link
                                                    to={this.props.vimeolLink}
                                                    className="icofont-vimeo"
                                                />
                                            </li>
                                        )}
                                        */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                </footer>
            </React.Fragment>
        );
    }
}

//Props Types
Footer.propTypes = {
    siteDescription: PropTypes.string,
    btnText: PropTypes.string,
    btnLink: PropTypes.string,

    usefullLinksTitle: PropTypes.string,

    supportTitle: PropTypes.string,
    supportsLinks: PropTypes.array,

    contactInfoTitle: PropTypes.string,
    contactInfoText: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,

    fbLink: PropTypes.string,
    twitterlLink: PropTypes.string,
    instagramlLink: PropTypes.string,
    linkedinlLink: PropTypes.string,
    vimeolLink: PropTypes.string
};

//Default Props
Footer.defaultProps = {
    siteDescription:
        "The Simple Event Planning / Tracking Tool that helps with Organizing events and Encourages people to Pitch In",
    btnText: "Read More",
    btnLink: "/faq",

    usefullLinksTitle1:  "Useful Links",
    usefullLinksTitle2:  "________________",

    
    supportTitle: "Support",   /*  Hide by changing color to white */
    supportsLinks: [
        // {
        //     Name: "Career",
        //     Link: "#"
        // },
        // {
        //     Name: "Support",
        //     Link: "#"
        // },
        // {
        //     Name: "Resource",
        //     Link: "#"
        // },
        // {
        //     Name: "Strategy",
        //     Link: "#"
        // },
        // {
        //     Name: "FAQ",
        //     Link: "#"
        // },
        // {
        //     Name: "Contact",
        //     Link: "#"
        // }
    ],

    contactInfoTitle: "Contact Info",
    contactInfoText: "Drop us a note below.",
    address: " ",
    phone: " ",
    email: " ",

    copyRightText: `Copyright \u00a9 ${new Date().getFullYear()} All Rights Reserved.`,
    fbLink: "https://www.facebook.com/pitchinclub",
    twitterlLink: "https://twitter.com/pitchinclub",
    instagramlLink: "#",
    linkedinlLink: "https://www.linkedin.com/company/pitch-in-club/",
    vimeolLink: "#"
};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js